import { Box } from '@mui/material';

export const StoreManagement = () => {
  return <Box sx={{ flex: 1 }}>Store Management</Box>;
};
